/* global axios */
import ApiClient from './ApiClient';

class LeadsAPI extends ApiClient {
  constructor() {
    super('leads', { accountScoped: true, apiVersion: 'v2' });
  }

  index(params = {}) {
    return axios.get(this.url, { params });
  }

  qualify(id, payload) {
    return axios.post(`${this.url}/${id}/qualify`, payload);
  }

  history(id) {
    return axios.get(`${this.url}/${id}/history`);
  }

  moveStage(id, payload) {
    return axios.post(`${this.url}/${id}/move_stage`, payload);
  }

  changePipeline(id, payload) {
    return axios.post(`${this.url}/${id}/change_pipeline`, payload);
  }

  win(id, payload) {
    return axios.post(`${this.url}/${id}/win`, payload);
  }

  lose(id, payload) {
    return axios.post(`${this.url}/${id}/lose`, payload);
  }

  reopen(id, payload) {
    return axios.post(`${this.url}/${id}/reopen`, payload);
  }

  discard(id, payload) {
    return axios.post(`${this.url}/${id}/discard`, payload);
  }

  generateSummary(id) {
    return axios.post(`${this.url}/${id}/generate_summary`);
  }

  bulkActions(payload) {
    return axios.post(`${this.url}/bulk_actions`, payload);
  }

  importLeads(file) {
    const formData = new FormData();
    formData.append('import_file', file);
    return axios.post(`${this.url}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new LeadsAPI();
